<div
  class="pc-layer"
  [class.pc-layer--selected]="selected"
  [class.pc-layer--text]="element.type === 'text'"
  [style.left.cm]="element.xCm"
  [style.top.cm]="element.yCm"
  [style.width.cm]="element.widthCm"
  [style.height.cm]="element.heightCm"
  [style.z-index]="element.zIndex"
  [style.transform]="rotationTransform"
  (pointerdown)="onPointerDown($event)"
  (contextmenu)="onContextMenu($event)"
>
  <div class="pc-layer__preview" [attr.data-type]="element.type">
    @if (element.type === "text") {
      <div
        #textNode
        class="pc-layer__text"
        [class.pc-layer__text--tagline]="element.variable === 'tagline'"
        [class.pc-layer__text--nowrap]="textMaxLines === 1"
        [class.pc-layer__text--clamp]="textLineClamp != null"
        [class.pc-layer__text--squash]="isSquashText"
        [class.pc-layer__text--right]="element.align === 'right'"
        [class.pc-layer__text--center]="element.align === 'center'"
        [style.font-family]="fontFamily"
        [style.font-size.pt]="displayFontSizePt"
        [style.font-weight]="isSquashText ? null : element.fontWeight || 400"
        [style.font-style]="
          isSquashText ? null : element.italic ? 'italic' : 'normal'
        "
        [style.text-transform]="
          isSquashText ? null : element.uppercase ? 'uppercase' : 'none'
        "
        [style.color]="isSquashText ? null : element.color || '#000000'"
        [style.text-align]="element.align || 'left'"
        [style.justify-content]="textJustifyContent"
        [style.white-space]="textWhiteSpace"
        [style.--pc-line-clamp]="textLineClamp"
        [style.--pc-line-height]="textLineHeight"
      >
        @if (isSquashText) {
          @if (squashSegments.length === 0) {
            <span class="pc-layer__text-line">{{
              element.name || element.variable || "squash"
            }}</span>
          } @else {
            <span class="pc-layer__text-line pc-layer__text-line--squash">
              @for (segment of squashSegments; track $index) {
                @if (segment.kind === "sep") {
                  <span
                    class="pc-layer__squash-sep"
                    [style.font-size.em]="
                      (segment.style.fontSizePt || squashBaseFontSizePt) /
                      squashBaseFontSizePt
                    "
                    [style.font-weight]="segment.style.fontWeight || 400"
                    [style.font-style]="
                      segment.style.italic ? 'italic' : 'normal'
                    "
                    [style.text-transform]="
                      segment.style.uppercase ? 'uppercase' : 'none'
                    "
                    [style.color]="segment.style.color || '#000000'"
                    [style.line-height]="
                      segment.style.lineHeight ?? element.lineHeight ?? 1
                    "
                    >{{ segment.text }}</span
                  >
                } @else {
                  <span
                    class="pc-layer__squash-part"
                    [style.font-size.em]="
                      (segment.part.fontSizePt ||
                        squashBaseFontSizePt) / squashBaseFontSizePt
                    "
                    [style.font-weight]="segment.part.fontWeight || 400"
                    [style.font-style]="
                      segment.part.italic ? 'italic' : 'normal'
                    "
                    [style.text-transform]="
                      segment.part.uppercase ? 'uppercase' : 'none'
                    "
                    [style.color]="segment.part.color || '#000000'"
                    [style.line-height]="
                      segment.part.lineHeight ?? element.lineHeight ?? 1
                    "
                    >{{ segment.text }}</span
                  >
                }
              }
            </span>
          }
        } @else {
          @for (line of textLines; track $index) {
            <span class="pc-layer__text-line">{{ line || "\u00a0" }}</span>
          }
        }
      </div>
    } @else if (mediaSrc; as src) {
      <img
        class="pc-layer__media"
        [style.object-position]="mediaObjectPosition"
        [src]="src"
        alt=""
        draggable="false"
      />
    } @else if (element.type === "shape") {
      <span
        class="pc-layer__shape"
        [style.background]="element.fill || '#eee'"
        [style.border-radius.mm]="element.borderRadiusMm || 0"
      ></span>
    } @else {
      <span class="pc-layer__badge">{{ label }}</span>
    }
  </div>
  @if (selected) {
    <button
      type="button"
      class="pc-handle pc-handle--nw"
      (pointerdown)="onResizePointerDown($event, 'nw')"
    ></button>
    @if (!keepSquare) {
      <button
        type="button"
        class="pc-handle pc-handle--n"
        (pointerdown)="onResizePointerDown($event, 'n')"
      ></button>
    }
    <button
      type="button"
      class="pc-handle pc-handle--ne"
      (pointerdown)="onResizePointerDown($event, 'ne')"
    ></button>
    @if (!keepSquare) {
      <button
        type="button"
        class="pc-handle pc-handle--e"
        (pointerdown)="onResizePointerDown($event, 'e')"
      ></button>
    }
    <button
      type="button"
      class="pc-handle pc-handle--se"
      (pointerdown)="onResizePointerDown($event, 'se')"
    ></button>
    @if (!keepSquare) {
      <button
        type="button"
        class="pc-handle pc-handle--s"
        (pointerdown)="onResizePointerDown($event, 's')"
      ></button>
    }
    <button
      type="button"
      class="pc-handle pc-handle--sw"
      (pointerdown)="onResizePointerDown($event, 'sw')"
    ></button>
    @if (!keepSquare) {
      <button
        type="button"
        class="pc-handle pc-handle--w"
        (pointerdown)="onResizePointerDown($event, 'w')"
      ></button>
    }
    <button
      type="button"
      class="pc-handle pc-handle--rotate"
      aria-label="Rotate"
      (pointerdown)="onRotatePointerDown($event)"
    >
      <mat-icon>rotate_right</mat-icon>
    </button>
  }
</div>
